import type Specialty from "parog-web/models/specialty";

//---- Automatically generated, don't update this part ----
/**
 * Describes a prescriptor
 */

interface Params {
  firstName: string;
  lastName: string;
  identifier: string;
  specialty: Specialty;
}

export default class Prescriptor {
  constructor(params: Params) {
    this.firstName = params.firstName;
    this.lastName = params.lastName;
    this.identifier = params.identifier;
    this.specialty = params.specialty;
  }

  toJson() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      identifier: this.identifier,
      specialty: this.specialty
    };
  }

  firstName: string;

  lastName: string;

  identifier: string;

  specialty: Specialty;

  //---- End of generated code ----
}
